/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsDeleteAodRulesByIdMutationResponse, AuditReportsDeleteAodRulesByIdPathParams, AuditReportsDeleteAodRulesById401, AuditReportsDeleteAodRulesById403 } from "../models/AuditReportsDeleteAodRulesById";

export function getAuditReportsDeleteAodRulesByIdUrl(id: AuditReportsDeleteAodRulesByIdPathParams["id"]) {
  const res = { method: 'DELETE', url: `/audit-reports/v1/aod-rules/${id}` as const }
  return res
}

/**
 * @summary Delete a single AodRule
 * {@link /audit-reports/v1/aod-rules/:id}
 */
export async function auditReportsDeleteAodRulesById(id: AuditReportsDeleteAodRulesByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsDeleteAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsDeleteAodRulesById401 | AuditReportsDeleteAodRulesById403>, unknown>({ method : "DELETE", url : getAuditReportsDeleteAodRulesByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}